export default {
  index: () => import('@v/Index'),

  'admin-permissions': () => import('@v/admin-permissions/Index'),
  'admin-permissions/create': () => import('@v/admin-permissions/Form'),
  'admin-permissions/:id(\\d+)/edit': () => import('@v/admin-permissions/Form'),

  'admin-roles': () => import('@v/admin-roles/Index'),
  'admin-roles/create': () => import('@v/admin-roles/Form'),
  'admin-roles/:id(\\d+)/edit': () => import('@v/admin-roles/Form'),

  'admin-users': () => import('@v/admin-users/Index'),
  'admin-users/create': () => import('@v/admin-users/Form'),
  'admin-users/:id(\\d+)/edit': () => import('@v/admin-users/Form'),
  'config-categories': () => import('@v/config-categories/Index'),

  configs: () => import('@v/configs/Index'),
  'configs/create': () => import('@v/configs/Form'),
  'configs/:id(\\d+)/edit': () => import('@v/configs/Form'),

  'vue-routers': () => import('@v/vue-routers/Index'),
  'vue-routers/create': () => import('@v/vue-routers/Form'),
  'vue-routers/:id(\\d+)/edit': () => import('@v/vue-routers/Form'),

  'system-media': () => import('@v/system-media/Index'),

  'admin-swiper-home': ()=>import('@v/admin-swiper-home/Index'),

  'admin-think': ()=>import('@v/admin-think/Index'),
  'admin-adver': ()=>import('@v/admin-adver/Index'),
  'admin-cooper': ()=>import('@v/admin-cooper/Index'),
  'admin-link': ()=>import('@v/admin-link/Index'),
  'admin-set': ()=>import('@v/admin-set/Index'),
  'admin-video': ()=>import('@v/admin-video/Index'),
  'admin-menu': ()=>import('@v/admin-menu/Index'),
  'admin-menu-index': ()=>import('@v/admin-menu-index/Index'),
  'admin-article':()=>import('@v/admin-article/Index'),
  'admin-article-add':()=>import('@v/admin-article-add/Index'),
}
